import "./index.css";

function Footer() {
  return (
    <div className="Footer">
      <div className="FooterCell">
        <a href="https://danielhan.dev/">
          <span className="FooterLink">&copy; {new Date().getFullYear()} Daniel Han</span>
        </a>
      </div>
    </div>
  );
}

export default Footer;
